"use client";

import React from "react";

import CoverType from "@/app/components/cover-type";
import CoverTypeProvider from "@/app/components/cover-type/provider/cover-type.provider";
import { CoverTypePageType } from "@/app/components/cover-type/types/cover-type.type";

function CoverTypePage({ cmsData }: CoverTypePageType) {
  return (
    <CoverTypeProvider initialValue={cmsData}>
      <CoverType />
    </CoverTypeProvider>
  );
}
export default CoverTypePage;
